import {useLazyQuery} from '@apollo/client'
import {useState, useEffect} from 'react'
import {Row, Col, Stack} from 'react-bootstrap'
import {
  GET_CUSTOMER_ENROLLMENT_DATA,
  GET_CUSTOMER_PRODUCT_INFO_FOR_GAS,
  GET_PRODUCT_LANAGUAGE,
} from '../../../../../utils/GraphQLAPI'
import {StepProps} from '../InterfaceAgentModal'
import ProductDetails from '../../../../sharedComponent/ProductDetails/ProductDetails'
import '../../agent.scss'
import ElectricIcon from '../../../../../_metronic/images/electric-icon.png'
import ElectricGasIcon from '../../../../../_metronic/images/gas-icon.png'
import uuid from 'react-uuid'

import {GLOBAL_CONSTANTS} from '../../../../../utils/GlobalConstants'
import ToggleButton from '../../../../sharedComponent/ToggleButton'
import ProductSelection from '../AgentModalComponents/ProductSelection'
import Tooltip from '../../../../sharedComponent/CustomTooltip/Tooltip'
import {alert} from '../../../../../utils/helper'

const ProductInfo = ({
  updateData,
  formik,
  method,
  products,
  getProductInfo,
  show,
  validationSchema,
  setValidationSchema,
  Yup,
  productDetails,
  setProductDetails,
  UANValidation,
  tpvMethods,
  isOptedIn,
  sendContract,
  sendContractEmail,
  isMixmatch,
  triggerOptinAlert,
  checkPhonenumberOptin,
  checkExistingCustomerForSymmetry,
  checkExistingCustomerFromAPI,
  getProductLanguage,
  languages,
}: StepProps) => {
  const [commodity, setCommodity] = useState<any>()
  const [brands, setBrands] = useState<any>()
  const [utilities, setUtilities] = useState<any>()
  const [contractTypes, setContractTypes] = useState<any>()

  const [mixmatchGasProducts, setMixmatchGasProduct] = useState<any>([])

  const [getCustomerProductInfoGas, {data: gasProducts}] = useLazyQuery(
    GET_CUSTOMER_PRODUCT_INFO_FOR_GAS,
    {
      variables: {
        filterInputs: {
          brandTypeId: formik.getFieldMeta('brandMixmatchId').value,
          contractTypeId: formik.getFieldMeta('contractTypeMixmatchId').value,
          utilityId: formik.getFieldMeta('utilityMixmatchId').value,
        },
        productId: formik.getFieldMeta('electricMixMatchProductId').value,
      },
      onCompleted: (data) => setMixmatchGasProduct(data?.getCustomerProductInfoForGas),
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
      onError: () => setMixmatchGasProduct([]),
    }
  )
  useEffect(() => {
    getCustomerData()
    getProductInfo()
    getCustomerProductInfoGas()
  }, [])
  const [getCustomerData] = useLazyQuery(GET_CUSTOMER_ENROLLMENT_DATA, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setCommodity(
        data.getCustomerEnrollmentData.commodities.map((eachCommidity: any) => ({
          id: eachCommidity.id,
          value: eachCommidity.name,
        }))
      )
      setBrands(
        data.getCustomerEnrollmentData.brands.map((eachBrand: any) => ({
          id: eachBrand.id,
          value: eachBrand.name,
        }))
      )
      setUtilities(
        data.getCustomerEnrollmentData.utilities.map((eachUtilities: any) => ({
          id: eachUtilities.id,
          value: eachUtilities.name,
        }))
      )
      setContractTypes(
        data.getCustomerEnrollmentData.contractTypes.map((eachcontractType: any) => ({
          id: eachcontractType.id,
          value: eachcontractType.name,
        }))
      )
    },
  })

  const handleSelectedItem = (e: any, name: any) => {
    formik.setFieldValue('productName', '')
    formik.setFieldValue('utilityAccountNumber', '')
    formik.setFieldValue('gutilityAccountNumber', '')
    if (name !== 'utilityMixmatch' && name !== 'contractTypeMixmatch' && name !== 'brandMixmatch') {
      formik.setFieldValue('electricMixMatchProductId', '')
    }

    formik.setFieldValue('gasMixMatchProductId', '')
    if (name === 'commodity' && e.value.length !== 0) {
      formik.setFieldValue('commodity', 'Electric')
      // setCommodityValue(e.target.value)
    }
    if (e.value.length > 0) {
      formik.setFieldValue(name, e.label)
      formik.setFieldValue(`${name}Id`, e.value)
    } else {
      formik.setFieldValue(name, '')
      formik.setFieldValue(`${name}Id`, null)
    }
  }

  const handleProductDropDownChange = (e: any, field: any, productsInList?: any) => {
    switch (field) {
      case 'languageId':
        formik.setFieldValue('languageId', e.target.value)
        break
      case 'productName':
        const selectedProduct = products.filter(({id}: any) => id === e.target.value)[0]

        formik.setFieldValue('selectedProductCommodity', selectedProduct?.commodity.name)
        formik.setFieldValue('productName', e.target.value)
        setProductDetails(selectedProduct)
        getProductLanguage({
          variables: {
            productId: e.target.value,
            tpvId: Boolean(formik.values.tpvId) ? formik.values.tpvId : null,
          },
        })
        break
      case 'electricMixMatchProductId':
        const selectedMixmatchElectric = products.filter(({id}: any) => id === e.target.value)[0]

        formik.setFieldValue('electricMixMatchProductId', e.target.value)
        formik.setFieldValue('gasMixMatchProductId', '')
        formik.setFieldValue('selectedProductCommodity', 'Dual')
        setProductDetails({...selectedMixmatchElectric, commodity: 'Dual'})
        getProductLanguage({
          variables: {
            productId: e.target.value,
            tpvId: Boolean(formik.values.tpvId) ? formik.values.tpvId : null,
          },
        })
        break
      case 'gasMixMatchProductId':
        const selectedMixmatchGas = gasProducts?.getCustomerProductInfoForGas.filter(
          ({id}: any) => id === e.target.value
        )[0]

        setProductDetails({
          ...productDetails,
          gcode: selectedMixmatchGas?.gcode,
          gearlyTerminationFee: selectedMixmatchGas?.gearlyTerminationFee,
          grate: selectedMixmatchGas?.grate,
          gserviceFee: selectedMixmatchGas?.gserviceFee,
          gterm: selectedMixmatchGas?.gterm,
          gutility: {uanValidation: Number(selectedMixmatchGas?.gUanValidation)},
        })
        formik.setFieldValue('gasMixMatchProductId', e.target.value)
        break
    }
  }

  return (
    <div className={'pb-5 '} data-kt-stepper-element='content'>
      <div className='w-100'>
        <div className='fv-row mb-10'>
          <label className='d-flex align-items-center fs-4 fw-bold mb-4 lh-1'>
            <span>Select Product</span>
          </label>
        </div>

        <div className='h-375px hover-scroll-overlay-y px-lg-5'>
          {method === 'create' && isMixmatch && (
            <div className='d-flex'>
              <ToggleButton
                isActive={formik.values.isMixMatch}
                onChange={(checked: any) => {
                  formik.setFieldValue('isMixMatch', checked)
                  if (checked) {
                    formik.setFieldValue(
                      'commodityId',
                      commodity.filter(
                        (commodityData: any) => commodityData.value === 'Electric'
                      )[0].id
                    )
                    formik.setFieldValue('commodity', 'Electric')
                    formik.setFieldValue(
                      'commodityMixmatchId',
                      commodity.filter((commodityData: any) => commodityData.value === 'Gas')[0].id
                    )
                    formik.setFieldValue('commodityMixmatch', 'Gas')
                  } else {
                    formik.setFieldValue('commodityId', '')
                    formik.setFieldValue('commodity', '')
                    formik.setFieldValue('commodityMixmatchId', '')
                    formik.setFieldValue('commodityMixmatch', '')
                  }
                }}
                rightText='Both Electric and Gas'
              />
            </div>
          )}

          <ProductSelection
            commodityConfig={{
              commodityFieldName: 'commodity',
              commodityHeader: `${formik.values.isMixMatch ? 'Electric ' : ''}Commodity`,
              isDisabled: formik.values.isMixMatch,
            }}
            utilityConfig={{
              utilityFieldName: `utility`,
              utilityHeader: `${formik.values.isMixMatch ? 'Electric ' : ''}Utility`,
            }}
            brandConfig={{
              brandFieldName: `brand`,
              brandHeader: `${formik.values.isMixMatch ? 'Electric ' : ''}Brand`,
            }}
            contractTypeConfig={{
              contractTypeFieldName: `contractType`,
              contractTypeHeader: `${formik.values.isMixMatch ? 'Electric ' : ''}Contract Type`,
            }}
            productConfig={{
              productFieldName: formik.values.isMixMatch
                ? 'electricMixMatchProductId'
                : 'productName',
              productHeader: formik.values.isMixMatch ? 'Electric Product Name' : 'Product Name',
            }}
            utilities={utilities}
            formik={formik}
            contractTypes={contractTypes}
            brands={brands}
            commodity={commodity}
            handleProductDropDownChange={handleProductDropDownChange}
            handleSelectedItem={handleSelectedItem}
            products={products}
          />
          {formik.values.isMixMatch && (
            <ProductSelection
              commodityConfig={{
                commodityFieldName: 'commodityMixmatch',
                commodityHeader: `Gas Commodity`,
                isDisabled: true,
              }}
              utilityConfig={{utilityFieldName: 'utilityMixmatch', utilityHeader: `Gas Utility`}}
              brandConfig={{brandFieldName: `brandMixmatch`, brandHeader: `Gas Brand`}}
              contractTypeConfig={{
                contractTypeFieldName: `contractTypeMixmatch`,
                contractTypeHeader: `Gas Contract Type`,
              }}
              productConfig={{
                productFieldName: 'gasMixMatchProductId',
                productHeader: 'Gas Product Name',
              }}
              utilities={utilities}
              formik={formik}
              contractTypes={contractTypes}
              brands={brands}
              commodity={commodity}
              handleProductDropDownChange={handleProductDropDownChange}
              handleSelectedItem={handleSelectedItem}
              products={mixmatchGasProducts}
            />
          )}
          {(productDetails?.commodity?.name === 'Electric' ||
            productDetails?.commodity?.name === 'Dual' ||
            formik.values.isMixMatch) && (
            <>
              <div className='fw-bold fs-6 mb-2 mt-4 required mt-7' style={{color: '#5E6278'}}>
                <img src={ElectricIcon} alt='electric-icon' />
                E_UAN (E_Utility Account Number)
              </div>
              <input
                type='text'
                className='form-control form-control-solid'
                name='utilityAccountNumber'
                placeholder='Enter Electric UAN number'
                {...formik.getFieldProps('utilityAccountNumber')}
                onChange={(e) => {
                  UANValidation(e.target.value)
                  formik.setFieldValue('utilityAccountNumber', e.target.value)
                  // handleUANOnBlur(e)
                }}
                onBlur={(e) => {
                  if (checkExistingCustomerFromAPI) {
                    checkExistingCustomerForSymmetry({
                      variables: {
                        customerInputs: {
                          customerUan: e.target.value,
                          zipcode: formik.values.serviceZipCode,
                        },
                      },
                    })
                  }
                }}

                // onBlur={(e) => handleUANOnBlur(e,formik.getFieldMeta('commodity').value)}
              />
              {formik.errors.utilityAccountNumber && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.utilityAccountNumber}
                  </div>
                </div>
              )}
            </>
          )}
          {(productDetails?.commodity?.name === 'Gas' ||
            productDetails?.commodity?.name === 'Dual' ||
            formik.values.isMixMatch) && (
            <>
              <div className='fw-bold fs-6 mb-2 required mt-7' style={{color: '#5E6278'}}>
                <img src={ElectricGasIcon} alt='electric-icon' />
                G_UAN (G_Utility Account Number)
              </div>
              <input
                type='text'
                className='form-control form-control-solid'
                name='gutilityAccountNumber'
                placeholder='Enter Gas UAN number'
                {...formik.getFieldProps('gutilityAccountNumber')}
                onChange={(e) => {
                  UANValidation(e.target.value)
                  formik.setFieldValue('gutilityAccountNumber', e.target.value)
                  // handleUANOnBlur(e)
                }}
                onBlur={(e) => {
                  if (checkExistingCustomerFromAPI) {
                    checkExistingCustomerForSymmetry({
                      variables: {
                        customerInputs: {
                          customerUan: e.target.value,
                          zipcode: formik.values.serviceZipCode,
                        },
                      },
                    })
                  }
                }}
                // onBlur={(e) => handleUANOnBlur(e)}
              />
              {formik.errors.gutilityAccountNumber && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.gutilityAccountNumber}
                  </div>
                </div>
              )}
            </>
          )}

          <Row className='mb-5 d-flex align-items-end mt-7 no-gutters noPadding'>
            <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
              <label className='d-flex align-items-center mb-2 required'>
                <span className='fs-6 fw-semibold lh-23px'>TPV Language</span>
              </label>
              <select
                className='form-select form-select-solid'
                aria-label='Select example'
                name='languageId'
                data-toggle='tooltip'
                title={
                  !Boolean(formik.getFieldMeta('productName').value) && 'Please select a product'
                }
                {...formik.getFieldProps('languageId')}
                onChange={(e) => handleProductDropDownChange(e, 'languageId')}
                disabled={
                  (formik.values.isMixMatch
                    ? !Boolean(formik.getFieldMeta('electricMixMatchProductId').value)
                    : !Boolean(formik.getFieldMeta('productName').value)) ||
                  formik.values.tpvStatus === 'PENDING' ||
                  formik.values.tpvStatus === 'INCOMPLETE' ||
                  formik.values.tpvStatus === 'FAILED' ||
                  formik.values.tpvStatus === 'UNVERIFIED'
                }
              >
                <option value=''>Choose Language</option>
                {languages?.map((_language: any) => {
                  return (
                    <option value={_language.languageId} key={uuid()}>
                      {_language.languageName}
                    </option>
                  )
                })}
              </select>
              {formik.errors.language && formik.touched.language && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.language}
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Row className='mb-5 d-flex align-items-end mt-7 no-gutters noPadding'>
            <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
              <label className='d-flex align-items-center mb-2 required'>
                <span className='fs-6 fw-semibold lh-23px'>TPV Method</span>
              </label>
              <select
                className='form-select form-select-solid'
                aria-label='Select example'
                name='languageId'
                value={formik.values.tpvType}
                onChange={(e) => {
                  if (e.target.value === 'SMS TPV' && !sendContractEmail) {
                    checkPhonenumberOptin({
                      variables: {
                        phoneNumber: formik.values.customerPrimaryPhoneNumber,
                      },
                    }).then((data: any) => {
                      console.log('datata', data)
                      if (data.data.checkPhoneNumberOptinStatus.optinStatus) {
                        formik.setFieldValue('tpvType', 'SMS TPV')
                      } else {
                        triggerOptinAlert()
                      }
                    })
                  } else {
                    formik.setFieldValue('tpvType', e.target.value)
                  }
                }}
                disabled={
                  formik.values.tpvStatus === 'PENDING' ||
                  formik.values.tpvStatus === 'INCOMPLETE' ||
                  formik.values.tpvStatus === 'FAILED' ||
                  formik.values.tpvStatus === 'UNVERIFIED'
                }
              >
                <option value=''>Choose TPV Method</option>
                {tpvMethods?.map((method: any) => (
                  <option value={method?.value} key={uuid()}>
                    {method.text}
                  </option>
                ))}
              </select>
              {formik.errors.language && formik.touched.language && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.language}
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Stack className='mt-5 mb-5' gap={3}>
            <ProductDetails products={productDetails} isMixMatch={formik.values.isMixMatch} />
          </Stack>
        </div>
      </div>
    </div>
  )
}

export {ProductInfo}
